/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

import CommunicatorUtility from '../communicator/utility/communicator-utility';

/**
 * Komunikátor automatického restartu pro Ki-Wi Server.
 */
class AutorebootCommunicator {
  /**
   * @param {CommunicatorSettings} settings
   * @returns {number|null}
   */
  getTnterval(settings) {
    const value = settings.get('autoreboot.interval');
    const hours = CommunicatorUtility.parseNumber(value);
    if (isNil(hours)) {
      return null;
    }
    return hours * 60 * 60 * 1000;
  }

  /**
   * @param {CommunicatorSettings} settings
   * @returns {boolean|null}
   */
  isDisabled(settings) {
    const value = settings.get('autoreboot.disabled');
    return CommunicatorUtility.parseBoolean(value);
  }
}

export default AutorebootCommunicator;
